import React from "react";
import { SectionCards } from "../../../index";
import { missionData } from "../../../../assets/data/aboutUsData";

export default function AboutUs(props) {
	return (
		<section className="mission-section no-px-md">
			<SectionCards
				data={missionData}
				inverted
				noSpace
				singleBG
				bulletPoint
			/>
		</section>
	);
}
